// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerLongCenter_container__qrA3_","content":"ContainerLongCenter_content__6hBID"};